import { computed } from '@vue/composition-api';

import { File, menu as FileMenu, state as FileState } from './file';
import { menu as EditMenu, state as EditState } from './edit';
import { Analysis, menu as AnalysisMenu, state as AnalysisState } from './analysis';
import { About, menu as AboutMenu, state as AboutState } from './about';
import { Admin, menu as AdminMenu, state as AdminState } from './admin';
import Loader from './analysis/components/Loader.vue';
import { filterMenus } from './utils';

/**
 * Gather all menu declarations.
 */
export const filemenu = computed(() => (
  filterMenus([
    FileMenu,
    EditMenu,
    { is: Loader }, // TODO: Place in Analysis menu itself
    AnalysisMenu,
    AboutMenu,
    AdminMenu,
  ])
));

/**
 * Gather all menu state.
 */
export const state = {
  file: FileState,
  edit: EditState,
  analysis: AnalysisState,
  about: AboutState,
  admin: AdminState,
};

/**
 * All menus that must render dialogs are registered here.
 * If a component is registered here, it MUST be a dialog of some sorts.
 */
export const components = {
  File,
  Analysis,
  About,
  Admin,
};
